import type { AxiosError } from 'axios';

interface ApiErrorPayload {
  code?: string;
  errorCode?: string;
  message?: string;
}

const isObject = (v: unknown): v is Record<string, unknown> => typeof v === 'object' && v !== null;

export const getApiErrorPayload = (error: AxiosError): ApiErrorPayload | undefined => {
  const data = error.response?.data;
  return isObject(data) ? (data as ApiErrorPayload) : undefined;
};
